import { render, staticRenderFns } from "./FormTemplateCopyDialog.vue?vue&type=template&id=0bc9d19e&scoped=true&"
import script from "./FormTemplateCopyDialog.vue?vue&type=script&lang=js&"
export * from "./FormTemplateCopyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc9d19e",
  null
  
)

export default component.exports